import { Component, OnDestroy, OnInit } from '@angular/core';
import { SelectedWorkspaceService } from '@cloud-twin-v2/cloud-twin-shared/selected-workspace.service';
import { InstanceUpdatesManagerService } from '@cloud-twin-v2/cloud-twin-shared/workers/instance-updates-manager.service';
import { SettingsService } from '@common-modules/shared/config/settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './cloud-twin-app.component.html',
  styleUrl: './cloud-twin-app.component.scss',
  standalone: false,
})
export class CloudTwinAppComponent implements OnInit, OnDestroy {
  constructor(
    private readonly _settingsService: SettingsService,
    private readonly _selectedWorkspaceService: SelectedWorkspaceService,
    private readonly _instanceUpdatesManagerService: InstanceUpdatesManagerService
  ) {
    this._settingsService.init();
    this._selectedWorkspaceService.init();
  }

  ngOnInit(): void {
    this._instanceUpdatesManagerService.start();
  }

  ngOnDestroy(): void {
    this._instanceUpdatesManagerService.stop();
  }
}
